import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "row"]

  add(event) {
    event.preventDefault()
    const tbody = this.listTarget.querySelector("tbody")
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    tbody.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("tr")
    const destroyInput = row.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
  }
}
